import {
  getInfosIndividual,
  getPermis,
  getProfilePresentation,
  getStudentGoal,
  downloadCv
} from '@webapps/business';
import {
  useAuth,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';

import { useEffect, useLayoutEffect, useRef, useState } from 'react';


import theme from './theme';

import './Montserrat-Regular-normal'
import CardTheme from '../profil/Components/CVGenerator/CardTheme';
import Settings from './components/Settings';
import Classique from './components/Themes/1/Classique';
import ClassiqueCopy from './components/Themes/2/ClassiqueCopy';

const {
  images: { CV_Linkpick, CV_Linkpick_pas_classique },
} = theme;

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    widthScreen: window.innerWidth,
    heightScreen: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        widthScreen: window.innerWidth,
        heightScreen: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);

    // Cleanup pour éviter les fuites mémoire
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

const getWindowsSize = () => {
  const { widthScreen, heightScreen } = useWindowSize();
  return { widthScreen, heightScreen };
};

// Cette element est présent ici mais aussi dans les thèmes
// A GLOBALISER

const percentage = {
  percentageThemeChoise: 0.15,
  percentageSettings: 0.2,
  percentageContent: 1 - 0.15 - 0.20
}

const CVStudent = () => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { widthScreen, heightScreen } = useWindowSize();

  const { addToast } = useToast();

  const colors = [
    {
      name: "grey",
      color: "#777",
    },
    {
      name: "blue",
      color: "#2563EB", // Bleu vif
    },
    {
      name: "red",
      color: "#EF4444", // Rouge vif
    },
    {
      name: "green",
      color: "#10B981", // Vert vif
    },
    {
      name: "purple",
      color: "#A78BFA", // Violet vif
    },
    {
      name: "orange",
      color: "#F59E0B", // Orange vif
    },
    {
      name: "emerald",
      color: "#34D399", // Émeraude vif
    },
    {
      name: "cyan",
      color: "#38BDF8", // Cyan vif
    },
    {
      name: "pink",
      color: "#F43F5E", // Rose vif
    },
    {
      name: "brown",
      color: "#F59E0B", // Jaune doré vif
    },
    {
      name: "blueNight",
      color: "#1E40AF", // Bleu royal
    },
  ];

  const { idUser: id } = useAuth();

  const [options, setOptions] = useState({
    skillsLanguageSelected: [],
    softSkillsSelected: [],
    softwareSkillsSelected: [],
    codingSkillsSelected: [],
    hobbiesSelected: [],
    trainingsSelected: [],
    certificationsSelected: [],
    achievementsSelected: [],
    transportsSelected: [],
    skillsProSelected: [],
    workExperiencesSelected: [],
    permisSelected: [],
    myGoalSelected: [],
  });
  const [dimensionsCv, setDimensionsCv] = useState({ width: 0, height: 0 });
  const [heightElementSidebar, setHeightElementSidebar] = useState(0);
  const [colorSelected, setColorSelected] = useState(colors[0].name);
  const [themeSelected, setThemeSelected] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  const [pages, setPages] = useState([]);

  const [scale, setScale] = useState(0.8); // Default scale
  const [contentRefs, setContentRefs] = useState([]);

  useEffect(() => {
    function handleResizeSetScale() {
      const windowWidth = window.innerWidth; // Récupérer la largeur actuelle de l'écran

      if (windowWidth > 1200) {
        setScale(0.70);
      } else if (windowWidth > 1000) {
        setScale(0.65);
      } else if (windowWidth > 870) {
        setScale(0.60);
      } else if (windowWidth > 760) {
        setScale(0.55);
      } else if (windowWidth > 600) {
        setScale(0.5);
      }
    }

    // Exécuter au chargement initial
    handleResizeSetScale();

    // Ajouter l'écouteur d'événement resize
    window.addEventListener('resize', handleResizeSetScale);

    // Cleanup pour éviter les fuites mémoire
    return () => window.removeEventListener('resize', handleResizeSetScale);
  }, []);

  const { data: { profileImageUrl = '' } = {} } = useQuery(
    getProfilePresentation,
    {
      key: 'coverImageProfilCV',
      variables: { id: id },
      refetchInterval: 250000,
      refetchIntervalInBackground: true,
    }
  );

  const themes = [
    {
      id: 1,
      name: 'Classique',
      key: 'classique',
      image: CV_Linkpick
    },
    {
      id: 2,
      name: 'Pas classique',
      key: 'pas_classique',
      image: CV_Linkpick_pas_classique
    },
  ]

  const { data: info = {}, isLoading: isLoadingInfo } = useQuery(getInfosIndividual, {
    key: ['indivudualInfos', id],
    variables: { id },
  });

  const { data: myGoal = [],
    isLoading: isLoadingMyGoal
  } = useQuery(getStudentGoal, {
    key: ['myGoal', info?.id],
    variables: { id: info?.id },
  });

  const data = {
    info,
    myGoal,
    profileImageUrl,
  };

  const handleChangeTheme = (theme) => {
    setThemeSelected(theme);
  }

  useEffect(() => {
    if (!colorSelected && colors.length > 0) {
      setColorSelected(colors[0]); // Définit la couleur par défaut une seule fois
    }
  }, []);

  // CALCUL CONTENT


  const {
    error: errorDownloadCv,
    isLoading: isLoadingDownloadCv,
    isSuccess: isSuccessDownloadCover,
    data: dataObject,
    mutateAsync: mutateDownloadCv,
  } = useMutation(downloadCv);

  const decodeHTMLEntities = (str) => {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = str;
    return textarea.value;
  };

  const handleGetContentRef = (ref) => {
    setContentRefs(ref);
  };

  const handleGeneratePDFWithNode = async () => {

    const contentElements = contentRefs.current;
    const htmlContents = contentElements.map((el) => decodeHTMLEntities(el.outerHTML)).join("");

    await mutateDownloadCv({
      data: { html: htmlContents },
    });
  };

  useEffect(() => {
    if (isSuccessDownloadCover) {
      const url = window.URL.createObjectURL(new Blob([dataObject]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${info?.firstname}_${info?.lastname}_cv.pdf`);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    } else if (errorDownloadCv) {
      addToast({
        status: 'error',
        message: 'Erreur lors du téléchargement du CV',
      });
    }
  }, [errorDownloadCv, isSuccessDownloadCover]);

  const infoSheetGlobal = {
    width: 794, // GLOBAL A TOUT LES THEMES
    height: 1123, // GLOBAL A TOUT LES THEMES
    colorPrimary: colorSelected?.colorHeader, // GLOBAL A TOUT LES THEMES
    colorSecondary: colorSelected?.colorSidebar, // GLOBAL A TOUT LES THEMES
    dividerColor: colorSelected?.colorTextContent, // GLOBAL A TOUT LES THEMES
    textHeaderDark: false, // GLOBAL A TOUT LES THEMES
  };


  return (
    <>
      <div
        className={css({
          display: 'flex',
          // width: '100%',
          // flexDirection: 'row',
          // justifyContent: 'space-between',
          height: 'calc(100vh - 64px)',

          // overflowY: 'hidden'
        })}
      >
        <div className={classes.themeCoiceContainer}>
          <div className={cx(global.title, classes.titleThemeContainer)}>Modèle</div>

          {themes.map((theme, index) => (
            <CardTheme handleChangeTheme={handleChangeTheme} key={index} theme={theme} themeSelected={themeSelected} />
          ))}

        </div>


        {themeSelected === 1 &&
          <Classique colorSelected={colorSelected} options={options}
            infoSheetGlobal={infoSheetGlobal} isLoadingInfo={isLoadingInfo}
            isLoadingMyGoal={isLoadingMyGoal} data={data}
            handleGetContentRef={handleGetContentRef}
          />
        }

        {
          themeSelected === 2 &&
          <ClassiqueCopy colorSelected={colorSelected} options={options}
            infoSheetGlobal={infoSheetGlobal} isLoadingInfo={isLoadingInfo}
            isLoadingMyGoal={isLoadingMyGoal} data={data}
            handleGetContentRef={handleGetContentRef}
          />
        }

        <Settings options={options} setOptions={setOptions}
          colorSelected={colorSelected} setColorSelected={setColorSelected}
          colors={colors} isLoading={isLoading} setIsLoading={setIsLoading}
          handleGeneratePDFWithNode={handleGeneratePDFWithNode}
          isLoadingDownloadCv={isLoadingDownloadCv} />
      </div>
    </>
  );
};

const styles = ({ spacing }) => ({
  themeCoiceContainer: {
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: '10px',
    backgroundColor: '#F3F7FF',
    width: getWindowsSize().widthScreen * percentage.percentageThemeChoise,
    height: '100%',
    overflowY: 'scroll'
  },
  themes: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  titleThemeContainer: {
    marginTop: '20px',
    // marginLeft: '15px',
    marginBottom: '20px',
  },
  settingsContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflowY: 'scroll',
    // gap: '20px',
    // padding: '20px',
    backgroundColor: '#F3F7FF',
    borderRadius: '12px',
    width: getWindowsSize().widthScreen * percentage.percentageSettings,
  },
  cvContainer: {
    overflowY: 'scroll',
    width: getWindowsSize().widthScreen * percentage.percentageContent,
    // backgroundColor: 'blue'
  },
  downloadButton: {
    width: 'calc(100% - 40px)', // 20px de margin * 2
    margin: "20px",
    marginTop: "30px"
  },
  container: {
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  containerAbsolute: {
    alignItems: 'center',
    display: 'flex',
    margin: '20px 0px',
    flexDirection: 'column',
    gap: '20px',
  },
  containerPreviewCV: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: getWindowsSize().widthScreen * 0.5,
  },

});

export default CVStudent;
